import { DepartureRow } from '../models/departureRow';
import DepartureOrArrivalTable from '@shared/components/DepartureOrArrivalTable';
import Message from '@shared/components/Message';
import LoadingPanel from '@shared/components/LoadingPanel';
import { DeepReadonly } from 'ts-essentials';
import { DepartureOrArrivalSorting } from '@shared/models/departureOrArrivalSorting';
import { DepartureOrArrivalTimeFormat } from '@shared/models/departureOrArrivalTimeFormat';
import { DepartureTimeSpan } from '@shared/models/departureTimeSpan';

interface DeparturesModuleProps {
  departureSorting: DepartureOrArrivalSorting;
  departurePaging: boolean;
  departureTimeFormat: DepartureOrArrivalTimeFormat;
  departureTimeSpan: DepartureTimeSpan;
  showPlatform: boolean;
  departureRows: DeepReadonly<DepartureRow[]> | undefined;
  departureRowsError: boolean | undefined;
  onPageViewed?: (isLastPage: boolean) => void;
}

export default function DeparturesModule({
  departureSorting,
  departurePaging,
  departureTimeFormat,
  departureTimeSpan,
  showPlatform,
  departureRows,
  departureRowsError,
  onPageViewed,
}: DeparturesModuleProps) {
  if (departureRowsError) {
    return (
      <Message
        title="Just nu kan vi inte visa avgångar på denna skylt"
        voicedTitle="Just nu kan vi inte hämta avgångar för denna hållplatsen"
        text="Sök din resa i appen Västtrafik To Go eller på vasttrafik.se"
      />
    );
  } else if (departureRows === undefined) {
    return <LoadingPanel />;
  } else if (departureRows.length > 0) {
    return (
      <DepartureOrArrivalTable
        departureRows={departureRows}
        sorting={departureSorting}
        timeFormat={departureTimeFormat}
        paging={departurePaging}
        showPlatform={showPlatform}
        onPageViewed={onPageViewed}
      />
    );
  } else {
    const messageTitle =
      departureTimeSpan === 'day'
        ? 'Det går inga avgångar härifrån det närmsta dygnet'
        : 'Det går inga avgångar härifrån den närmsta timmen';
    const messageText =
      departureTimeSpan === 'day'
        ? 'Sök alternativa resor i appen Västtrafik To Go eller på vasttrafik.se'
        : 'Sök alternativa resor i appen Västtrafik To Go eller på vasttrafik.se';
    return <Message title={messageTitle} text={messageText} />;
  }
}
